export const SidebarIdItamSettings = 'ITAM_SETTINGS' as const;
